import { IonContent, IonPage } from '@ionic/react';
import * as React from 'react';
import { useParams } from 'react-router';
import DesktopDetailPageHeader from 'src/components/reusable-components/desktop-header/DesktopDetailPageHeader';
import MobileDetailPageHeader from 'src/components/reusable-components/mobile-detail-page-header/MobileDetailPageHeader';
import { useIsMobile } from 'src/utils/helpers/platformHelpers';
import { useGA4 } from '../utils/ga4';

export const PdfViewerPage: React.FC = () => {
  useGA4();

  const params = useParams<{ file?: string }>();
  const isMobile = useIsMobile();

  const title = React.useMemo(() => {
    if (!params.file) return '';
    const split = decodeURIComponent(params.file).split('/');
    if (!split.length) return '';
    return split[split.length - 1] ?? '';
  }, [params.file]);
  document.title = title;

  return (
    <IonPage>
      {isMobile ? <MobileDetailPageHeader title={title} /> : <DesktopDetailPageHeader heading={title} />}
      <IonContent scrollX={false} scrollY={false}>
        {!params.file ? null : (
          <iframe title={title} src={`/pdf/web/viewer.html?file=${params.file}`} width="100%" height="100%" />
        )}
      </IonContent>
    </IonPage>
  );
};
